import React from 'react';
import { ValidatorError } from '@unitedtraders/validators';

type ContextProps = {
  submittedAtLeastOneTime: boolean;
  tips: {
    [key: string]: ValidatorError;
  };
};

export const Context = React.createContext<Partial<ContextProps>>({
  submittedAtLeastOneTime: false,
  tips: {}
});
